import Stripes from './components/Stripes.vue'
import Map from './components/Map.vue'
import Faq from './components/Faq.vue'

export const routes = [
	{ path: '/map', name: 'map', component: Map },
	{ path: '/faq', name: 'faq', component: Faq },
	{
		path: '/:stripeType?/:pH?/:lmebasin?/:ocean?/:region?',
		name: 'stripes',
		component: Stripes,
	},
]
